"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Cooltip_1 = require("../Cooltip");
require("./TextInput.scss");
exports.TextInput = function (props) {
    var labelText = props.labelText, name = props.name, isRequired = props.isRequired, placeholder = props.placeholder, value = props.value, defaultValue = props.defaultValue, isTextArea = props.isTextArea, readOnly = props.readOnly, disabled = props.disabled, validationState = props.validationState, errorMessage = props.errorMessage, inputSize = props.inputSize, type = props.type, onChange = props.onChange, onBlur = props.onBlur, labelProps = props.labelProps, inputProps = props.inputProps, children = props.children, rest = __rest(props, ["labelText", "name", "isRequired", "placeholder", "value", "defaultValue", "isTextArea", "readOnly", "disabled", "validationState", "errorMessage", "inputSize", "type", "onChange", "onBlur", "labelProps", "inputProps", "children"]);
    var thisType = type ? type : 'text';
    var labelPropsObj = labelProps ? labelProps : {};
    var inputPropsObj = inputProps ? inputProps : {};
    var mergedInputProps = __assign({ value: value, defaultValue: defaultValue, placeholder: placeholder, name: name, onChange: onChange, onBlur: onBlur, disabled: disabled }, inputProps);
    var sizeClass;
    switch (inputSize) {
        case 'full':
            sizeClass = 'input-lg';
            break;
        case 'minimal':
            sizeClass = 'input-sm';
            break;
        default:
            sizeClass = null;
    }
    var validationClass = '';
    if (validationState === 'invalid') {
        validationClass = 'invalid';
    }
    else if (validationState === 'valid') {
        validationClass = 'valid';
    }
    var divClasses = classNames({ 'form-group': true }, props.className);
    var labelClasses = classNames({ 'required-input-label': isRequired }, labelPropsObj.className);
    var inputClasses = classNames({ 'form-control': true }, validationClass, inputPropsObj.className, sizeClass);
    function handleInputChange(e) {
        if (onChange) {
            onChange(e);
        }
    }
    function handleInputBlur(e) {
        if (onBlur) {
            onBlur(e);
        }
    }
    function wrapInputWithTooltip(el) {
        if (!errorMessage) {
            return el;
        }
        return (React.createElement(Cooltip_1.Cooltip, { placement: 'bottom', tooltipContents: errorMessage, tooltipType: 'error', hidden: validationState !== 'invalid' }, el));
    }
    var input;
    // tslint:disable-next-line:prefer-conditional-expression
    if (!isTextArea) {
        input = React.createElement("input", __assign({}, mergedInputProps, { onChange: handleInputChange, onBlur: handleInputBlur, className: inputClasses, type: thisType }, { readOnly: readOnly }, { style: { color: props.valueColor } }));
    }
    else {
        input = React.createElement("textarea", __assign({}, mergedInputProps, { onChange: handleInputChange, onBlur: handleInputBlur, className: inputClasses }, { readOnly: readOnly }, { style: { color: props.valueColor } }));
    }
    var inputComponent = wrapInputWithTooltip(input);
    var labelComponent = labelText && (React.createElement("label", __assign({}, labelPropsObj, { className: labelClasses, htmlFor: name, style: { color: props.labelColor } }), labelText));
    return (React.createElement("div", __assign({ className: divClasses }, rest),
        labelComponent,
        inputComponent));
};
exports.IsValidEmailAddress = function (email) {
    // overall email address - maximum 320 characters
    if (email.length > 320) {
        return false;
    }
    var isEmail = /^([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)@((([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})|(\[(\b(?:[0-9]{1,3}\.){3}[0-9]{1,3}\b)\])|(\[(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}(?![:.\w])\]))$/i;
    var match = isEmail.exec(email);
    if (match !== null) {
        // local part - maximum 64 characters
        if (match[1].length > 64) {
            return false;
        }
        // domain - maximum 255 characters
        if (match[3].length > 255) {
            return false;
        }
        // any domain label length no more than 63 characters long (exclude ipv4 and ipv6)
        var subs = match[3].split('.').map(function (a) { return a.startsWith('-') || a.endsWith('-') ? 64 : a.length; });
        if (!match[7] && !match[8] && subs.some(function (v) { return v > 63; })) {
            return false;
        }
        return true;
    }
    return false;
};
//# sourceMappingURL=TextInput.js.map